import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PetVaccinationPayload {
  pet_id: number;
  warehouse_id: number;
  vaccine_name: string;
  manufacturer?: string | null;
  batch_number?: string | null;
  vaccination_date?: string | null;
  next_due_date?: string | null;
  authorized_vet?: string | null;
  veterinarian?: string | null;
  notes?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PetsService {
  private apiUrl = `${environment.Server_URL}/pets`;
  private vaccinationUrl = `${environment.Server_URL}/vaccinations`;

  constructor(private http: HttpClient) {}

  /**
   * 🟢 Get all pets
   */
  getAllPets(warehouseId?: number, clientId?: number): Observable<any> {
    const params: any = {};

    if (warehouseId) {
      params.warehouse_id = warehouseId;
    }

    if (clientId) {
      params.client_id = clientId;
    }

    return this.http.get(this.apiUrl, { params });
  }

  /**
   * 🟢 Get a specific pet by ID
   */
  getPetById(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  /**
   * 🟢 Create new pet
   */
  createPet(payload: any): Observable<any> {
    return this.http.post(this.apiUrl, payload);
  }

  /**
   * 🟡 Update pet info
   */
  updatePet(id: number, payload: any): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, payload);
  }

  /**
   * 🔴 Delete pet
   */
  deletePet(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  /**
   * 🟢 Get vaccinations for specific pet
   */
  getVaccinationsByPetId(petId: number, warehouseId?: number): Observable<any> {
    const params: any = {};

    if (warehouseId) {
      params.warehouse_id = warehouseId;
    }

    return this.http.get(`${this.apiUrl}/${petId}/vaccinations`, { params });
  }

  /**
   * 🟢 Add new vaccination for a pet
   */
  addVaccination(payload: PetVaccinationPayload): Observable<any> {
    return this.http.post(this.vaccinationUrl, payload);
  }

  /**
   * 🟡 Update vaccination record
   */
  updateVaccination(
    id: number,
    payload: Partial<PetVaccinationPayload>
  ): Observable<any> {
    return this.http.put(`${this.vaccinationUrl}/${id}`, payload);
  }

  /**
   * 🔴 Delete vaccination record
   */
  deleteVaccination(id: number): Observable<any> {
    return this.http.delete(`${this.vaccinationUrl}/${id}`);
  }

  /**
   * 🟢 Get upcoming vaccinations within 7 days
   */
  getUpcomingVaccinations(warehouseId: number, petId?: number): Observable<any> {
    const params: any = {};

    if (warehouseId) {
      params.warehouse_id = warehouseId;
    }

    if (petId) {
      params.pet_id = petId;
    }

    return this.http.get(`${this.vaccinationUrl}/upcoming`, { params });
  }
}